export default {
  required: '请输入',
  requiredSelect: '请选择',
  basicInfo: '基础信息',
  serviceProvider: '服务商',
  serviceProviderPlaceholder: '请选择服务商',
  apiKey: 'API Key',
  apiKeyPlaceholder: '请输入API Key',
  apiSecret: 'API Secret',
  apiSecretPlaceholder: '请输入API Secret',
  smsSignature: '短信签名',
  smsSignaturePlaceholder: '请输入短信签名',
  channelConfig: '海外通道配置',
  addChannel: '添加通道',
  countryRegion: '国家/地区',
  operator: '服务商',
  operatorPlaceholder: '请选择',
  templateCode: '模板code',
  templateCodePlaceholder: '请输入模板code',
  status: '状态',
  actions: '操作',
  edit: '编辑',
  delete: '删除',
  sendTest: '短信发送测试',
  testPhone: '请输入手机号',
  sendTestSms: '发送测试短信',
  sendTestSuccess: '测试短信发送成功',
  sendTestFail: '测试短信发送失败',
  save: '保存配置',
  saveSuccess: '保存成功',
  deleteConfirm: '确认删除该通道？',
  deleteSuccess: '删除成功',
  selectChannel: '请选择通道',
  // Tab
  tabConfig: '短信配置',
  tabSendLog: '发送日志',
  // 日志筛选
  logMobile: '手机号',
  logMobilePlaceholder: '请输入手机号',
  logTemplateCode: '模板Code',
  logTemplateCodePlaceholder: '请输入模板Code',
  logStatus: '发送状态',
  logStatusAll: '全部状态',
  logStatusSuccess: '成功',
  logStatusFailed: '失败',
  logProvider: '服务商',
  logProviderAll: '全部服务商',
  logSendTime: '发送时间',
  logStartDate: '开始日期',
  logEndDate: '结束日期',
  logSearch: '查询',
  logReset: '重置',
  logCollapse: '收起',
  logExpand: '展开',
  logAllCountries: '全部国家/地区',
  // 日志表格
  logColumnCountry: '国家/地区',
  logColumnMobile: '手机号',
  logColumnTemplateCode: '模板Code',
  logColumnProvider: '服务商',
  logColumnStatus: '状态',
  logColumnSendTime: '发送时间',
  logColumnMessageId: '服务商消息ID',
  logColumnActions: '操作',
  logDetail: '详情',
  // 统计卡片
  statTotalCount: '发送总数',
  statSuccessCount: '成功数',
  statFailedCount: '失败数',
  statSuccessRate: '成功率',
  // 详情抽屉
  detailTitle: '短信发送详情',
  detailMobile: '手机号',
  detailCountry: '国家/地区',
  detailProvider: '服务商',
  detailTemplateCode: '模板Code',
  detailTemplateName: '模板名称',
  detailContent: '短信内容',
  detailStatus: '发送状态',
  detailMessageId: '服务商消息ID',
  detailRequestId: '平台请求ID',
  detailSendTime: '发送时间',
  detailCallbackTime: '回调时间',
  detailResponse: '返回结果',
  detailErrorCode: '错误码',
  detailErrorMsg: '错误信息',
  detailClose: '关闭',
  detailNone: '-',
};
